import { twMerge } from 'tailwind-merge';
import { HeadingLoader } from '../../Heading/HeadingLoader';
import { TextLoader } from '../../Text/TextLoader';

export const HeadlineLoader = ({ className }: { className?: string }) => {
  return (
    <div className={twMerge('flex flex-col', className)}>
      <HeadingLoader
        variant="sm"
        uniqueKey="nearby-waters-section-heading-loader"
        className="mb-2"
        width="350px"
      />
      <TextLoader
        variant="sm"
        uniqueKey="nearby-waters-section-text-loader"
        className="mb-0"
        width="150px"
      />
    </div>
  );
};
